import "./search_form.css";
import SearchBar from "../../components/search_bar/search_bar";

const reactRootDomSelectors = {
  "#search_form__js-search-riing": { component: SearchBar }
};

export { reactRootDomSelectors };
